import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import Reveal from "./Reveal";

const ITEMS = [
  {
    q: "Czy mogę zmienić ubezpieczenie w trakcie roku?",
    a: "Tak, w wielu przypadkach jest to możliwe — szczególnie przy ubezpieczeniach komunikacyjnych po zakupie pojazdu lub przy polisach majątkowych. Podczas rozmowy sprawdzimy dokładnie Twój termin oraz możliwości wypowiedzenia.",
  },
  {
    q: "Czy porównujecie oferty różnych towarzystw?",
    a: "Tak. Współpracujemy z ponad 25 największymi Towarzystwami Ubezpieczeniowymi, dlatego przedstawiamy różne możliwości dopasowane do Twojej sytuacji.",
  },
  {
    q: "Jak szybko otrzymam odpowiedź?",
    a: "Najczęściej kontaktujemy się jeszcze tego samego dnia roboczego.",
  },
  {
    q: "Czy mogę wszystko załatwić telefonicznie?",
    a: "W większości przypadków tak. Wiele spraw możemy przeprowadzić telefonicznie lub online, bez konieczności wizyty w biurze.",
  },
  {
    q: "Czy obsługujecie klientów spoza Leska?",
    a: "Tak. Współpracujemy z klientami z całego Podkarpacia i Bieszczad.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="container-narrow">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="text-mustard-dark font-heading font-bold uppercase text-sm tracking-wider mb-3">
                FAQ
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-forest leading-tight">
                Najczęściej zadawane pytania.
              </h2>
              <p className="mt-5 text-ink-muted text-base md:text-lg leading-relaxed">
                Nie znalazłeś odpowiedzi? Zadzwoń lub napisz. Chętnie odpowiemy osobiście.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {ITEMS.map((it, i) => (
                  <AccordionItem
                    value={`item-${i}`}
                    key={i}
                    className="border-b border-bordersoft"
                  >
                    <AccordionTrigger
                      data-testid={`faq-question-${i}`}
                      className="font-heading text-forest font-semibold text-lg md:text-xl text-left hover:no-underline py-5"
                    >
                      {it.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-ink-muted text-base md:text-lg leading-relaxed pb-5">
                      {it.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
